import {
  RolloutDocument,
  withStandardPrefetchHook,
} from '@spotify/confidence-graphql';

export const useRolloutPrefetch = withStandardPrefetchHook(RolloutDocument);
